import React from "react";

const Login = () => {
  return (
    <div>
      <div className="w-[700px] h-[600px] bg-[#4C004A] font-semibold m-auto mt-10 rounded-2xl">
        <div className="grid gap-10 text-center text-white">
          <img src="logo.svg" alt="logo" className="m-auto mt-5" />
          <h1 className="text-white text-2xl">LOGIN</h1>
          {/* select branch */}
          <select class=" w-[50%] m-auto bg-transparent border-b border-gray-500 focus:outline-none focus:bg-[#4C004A]">
            <option selected className="bg-transparent" value="">
              Branch
            </option>
            <option className="bg-transparent" value="option2">
              Branch 2
            </option>
            <option className="bg-transparent" value="option3">
              Branch 3
            </option>
          </select>

          {/* Username */}
          <div className=" w-[50%] m-auto flex items-center border-b-2 border-white focus-within:border-white ">
            <input
              type="text"
              className="bg-transparent border-none flex-grow focus:outline-none placeholder-white"
              placeholder="Username"
            />
            <img src="/icons/person2.svg" className="-mt-2" />
          </div>
          {/* Passowrd */}
          <div className=" w-[50%] m-auto flex items-center border-b-2 border-white focus-within:border-white ">
            <input
              type="text"
              className="bg-transparent border-none flex-grow focus:outline-none placeholder-white"
              placeholder="Password"
            />
            <img src="/icons/lock.svg" className="-mt-2" />
          </div>
          <button className=" w-[20%] m-auto bg-[#DAE4FD] hover:bg-[#DAE4FD] text-black py-2 px-4 rounded font-black">
            Login
          </button>
        </div>
        <p className="text-right text-white mx-40 mt-10">Powered by</p>
      </div>
    </div>
  );
};

export default Login;
